import React from 'react';
interface SectionHeaderProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  eyebrowTone?: 'terracota' | 'olive';
}
export function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  eyebrowTone = 'terracota'
}: SectionHeaderProps) {
  const tones = {
    terracota: 'text-terracota',
    olive: 'text-olive'
  };
  return <div className="text-center" data-id="element-159" data-mp="27ekhlry51vf1">
      {eyebrow && <p className={`font-hand text-xl font-bold leading-tight sm:text-2xl ${tones[eyebrowTone]}`} data-id="element-160" data-mp="2v7ss54g6f50e">
          {eyebrow}
        </p>}
      <h2 id={id} className="mt-1 font-serif text-2xl leading-tight text-marron sm:text-4xl" data-id="element-161" data-mp="303823lb2cgrj">
        {title}
      </h2>
      {description && <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-marron/80 sm:text-base" data-id="element-162" data-mp="2q6d9fj1h1al6">
          {description}
        </p>}
    </div>;
}